import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/orgs/$orgId/')({
  beforeLoad: async ({ params }) => {
    return redirect({
      to: '/orgs/$orgId/projects',
      params: { orgId: params.orgId },
      throw: true,
    })
  },
})
